import styled from "styled-components";
import { Z_INDEX } from "@constants";

export const SplashCommon = () => {
    return (
        <StyledWrapper>
            <img src="/images/logos/Primary_logo_color.svg" alt="splash" />
        </StyledWrapper>
    );
};

const StyledWrapper = styled.div`
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: ${Z_INDEX.SPLASH};
    top: 0;
    left: 0;

    img {
        width: 200px;
        animation: fadeIn ease-in-out 1s forwards;
        transform: translateY(-100px);
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }
`;
